<template lang="pug">
  transition(name="slide-right")
    .modal.slideout(
      v-if="isVisible"
    )
      .slideout__overlay(@click="close")
      .slideout__content
        icon-button.modal__close(icon="close", @click="close" size="16px")
        .slideout__content-header
          .h3 Stores
        .slideout__inner
          .slideout__options
            checkbox-toggle-all(
              label="All Stores"
              :checked="toggleAllState"
              :allOptions="dropdownOptions"
              @input="toggleAllValues"
            )
            checkbox-input(
              v-for="(value, key) in dropdownOptions"
              :key="key"
              :label="key"
              :value="key"
              :checked="value"
              @input="updateCheckboxValue(key)"
            )
</template>

<script>
  import CheckboxInput from 'scripts/components/forms/CheckboxInput.vue'
  import CheckboxToggleAll from 'scripts/components/forms/CheckboxToggleAll.vue'
  import Icon from 'scripts/components/basic/Icon.vue'
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import Modal from 'scripts/components/basic/Modal.vue';

  export default {
    name: 'ProductLocationFilterSlideout',
    components: {
      CheckboxInput,
      CheckboxToggleAll,
      IconButton,
      Icon,
    },
    extends: Modal,
    props: {
      zipModalHeading: String,
      zipModalBody: String,

      options: Object,
      enableToggleAll: {
        type: Boolean,
        default: false
      },
      label: String,
    },
    data() {
      return {
        isVisible: false,
        toggleOpen: false,
        dropdownOptions: this.options
      };
    },
    computed: {
      toggleAllState() {
        if (Object.values(this.dropdownOptions).every(Boolean)) {
          return 'checked'
        } else if (Object.values(this.dropdownOptions).every(option => option === false)) {
          return 'unchecked'
        } else {
          return 'intermediary'
        }
      },
    },
    methods: {
      open() {
        this.isVisible = true;
        this.$emit('open');
      },
      close() {
        this.isVisible = false;
        this.$emit('close');
      },
      toggleAllValues(value) {
        const valToBool= value === 'checked' ? true : false;
        Object.keys(this.dropdownOptions).forEach((key) => this.dropdownOptions[key] = valToBool);
      },
      updateCheckboxValue(option) {
        this.dropdownOptions[option] = !this.dropdownOptions[option];
      }
    },
    watch: {
      options() {
        this.dropdownOptions = this.options
      }
    },
  };
</script>

<style lang="scss" scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9000;
    width: 100%;
    min-height: 100vh;
    overflow-y: auto;
    background-color: transparent;
  }

  .slideout__overlay {
    background-color: transparentize($color-grey-500, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
  }

  .modal__close {
    color: var(--color-slate-500);
    background-color: transparent;
    border-width: 0;
    position: absolute;
    top: 15px;
    right: 15px;

    &:hover {
      background-color: transparent;
    }
  }

  .slideout__content {
    position: absolute;
    left: 0;
    z-index: 1000;
    margin-bottom: 50px;
    padding: 30px;
    max-width: 100%;
    background-color: var(--color-white);
    border: 1px solid var(--color-grey-300);
    text-align: center;

    @include mobile-only {
      width: 90%;
      min-height: 100vh;
    }

    @include tablet-up {
      top: 50px;
      padding: 65px;
      min-width: 500px;
    }

    .collection-grid__actions-modal & {
      padding: 0;
    }
  }

  .slideout__content-header {
    border-bottom: 1px solid var(--color-grey-500);
    color: var(--color-navy-500);
    padding-bottom: 25px;
    margin-bottom: 30px;
    text-align: left;
  }

  .slideout__options {
    display: flex;
    flex-direction: column;
    text-align: left;

    .checkbox-input {
      margin-bottom: 30px;
    }
  }

  </style>